// extracted by mini-css-extract-plugin
export default {"mainContainer":"FullPageLoader_mainContainer__ihszi","loadingContainer":"FullPageLoader_loadingContainer__enFAH","loader":"FullPageLoader_loader__BII0U"};